const STRIPE = {
  REDIRECT_FAILED:
    'Error occured while trying to redirect to Stripe to complete checkout request.',
  DISCONNECTED:
    "You're now disconnected from Stripe.\nReconnect anytime to access its amazing features again.",
  ENABLED:
    'Stripe is enabled again!\nAll its amazing features are ready for you to enjoy.',
  DISABLED:
    "Stripe is disabled.\nYou're still connected, so turning it back on is easy whenever you're ready!",
} as const;
export default STRIPE;
